import { Theme } from '@radix-ui/themes'
import clsx from 'clsx'
import React from 'react'
import ReactDOM from 'react-dom'
import { useSelector } from 'hooks/use-redux'
import { getLabelSelectedItems } from '@disco/utils/string-utils'
import ButtonContainer from 'components/ui/button-container'
import styles from './index.module.css'
import { SelectableItem } from '@disco/types/types/selection'

let appNode

if (typeof document !== 'undefined') {
  appNode = document.getElementById('app') || document.getElementById('__next')
}

const ExplorerActionMenuContainer = ({
  selectedItems,
  buttons,
  children,
  label,
  className,
}: {
  selectedItems: SelectableItem[]
  buttons?: React.ReactNode[]
  children: React.ReactNode
  /** Overrides the default "Edit N items" label. */
  label?: string
  /** Extra class on the floating bar, e.g. to adjust its position. */
  className?: string
}): any => {
  const hasPlayer = useSelector(state => Boolean(state.media.trackOriginalId))
  if (!appNode) return null
  return ReactDOM.createPortal(
    <Theme appearance="dark">
      <div
        className={clsx(styles.explorerActionMenuContainer, className, {
          [styles.explorerActionMenuContainerWithPlayer]: hasPlayer,
        })}
      >
        <span className={styles.explorerActionMenuContainerLabel}>
          {label ?? getLabelSelectedItems(selectedItems)}
        </span>

        <ButtonContainer>
          {buttons}

          {children}
        </ButtonContainer>
      </div>
    </Theme>,
    appNode,
  )
}

export default ExplorerActionMenuContainer
